import {NotificationType} from "../../helpers/types";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface NotificationsState {
    items: NotificationType[];
}

const initialState: NotificationsState = {
    items: [],
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        pushNotification: (state, action: PayloadAction<NotificationType>) => {
            state.items.unshift(action.payload); // добавляем в начало
        },
        clearNotifications: (state) => {
            state.items = [];
        },
        setNotificationsArray: (state, action: PayloadAction<NotificationType[]>) => {
            state.items = action.payload;
        }
    },
});

export const { pushNotification, clearNotifications, setNotificationsArray } = notificationsSlice.actions;
export default notificationsSlice.reducer;